<script lang="ts">
  import {fly} from 'svelte/transition';
  import {personalInfo, deal, Step, currentStep} from 'Store/InvestorFlowStore';
  import AmountSelection from 'Components/InvestorFlow/v2/Components/LeftContainer/AmountSelection.svelte';
  import PersonalInfo from 'Components/InvestorFlow/v2/Components/LeftContainer/PersonalInfo.svelte';
  import IncentiveTierCodesForm from 'Components/InvestorFlow/v2/Components/LeftContainer/IncentiveTierCodesForm.svelte';
  import {incentivePlans} from 'Store/deals/incentivePlan';

  // fix for multiple embedded checkouts rendered under different "tabs"
  currentStep.set(Step.PERSONAL_INFO);

  let customInvestmentAmount = $personalInfo.investment_amount;
</script>

{#if $currentStep === Step.PERSONAL_INFO}
  <PersonalInfo />
{:else if $currentStep === Step.INVESTMENT_AMOUNT}
  <div class="centered" in:fly={{x: 300, duration: 150}}>
    <AmountSelection
      minimum_investment={$deal.minimum_investment}
      maximum_investment={$deal.maximum_investment}
      price_per_security={$incentivePlans.final_price.amount_cents}
      currency={$deal.currency}
      bind:customInvestmentAmount
    />
  </div>
{:else if $currentStep === Step.INCENTIVE_TIER}
  <div class="centered" in:fly={{x: 300, duration: 150}}>
    <IncentiveTierCodesForm />
  </div>
{/if}
